
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/features/tanabata",
      function () {
        return require("private-next-pages/phone/features/tanabata.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/features/tanabata"])
      });
    }
  